import { IonIcon } from "@ionic/react";
import {
  logoWhatsapp,
  logoYoutube,
  chevronUpOutline,
  chevronDownOutline,
  peopleOutline,
  logoInstagram,
} from "ionicons/icons";
import React, { useState } from "react";
import styled, { css, keyframes } from "styled-components";
import { devices } from "../../Devices";

const float = keyframes`
  0% { transform: translateY(0);}
  50% { transform: translateY(-10px);}
  100% { transform: translateY(0);}
`;

const Contact = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  box-shadow: 0 0 10px rgba(1, 1, 1, 0.15);
  font-size: 1.6rem;
  padding: 0.8rem 2.4rem;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  z-index: 10;
  background-color: #d97706;
  color: #fff;
  cursor: pointer;
  .icon {
    font-size: 1.6rem;
  }
  transition: all ease-in-out 200ms;
  &:hover {
    color: #ffc179;
  }
  @media (max-width: 600px) {
    bottom: 0;
    a {
      justify-content: center;
    }
  }
  ${({ color }) =>
    color === "white" &&
    css`
      background-color: #fff;
      color: #824704;
      &:hover {
        background-color: #824704;
        color: #fff;
      }
    `}

  ${({ makeItSmallerOnMobile }) =>
    makeItSmallerOnMobile &&
    css`
      @media ${devices.mobileL} {
        padding: 0.4rem 1.2rem;
      }
    `};
`;

const MainButton = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  justify-content: center;
  font-weight: bold;
  font-size: 1.6rem;
  padding: 0.8rem 2.4rem;
  border-radius: 15px 15px 0 0;
  background: inherit;
  color: inherit;
  cursor: pointer;
  .icon {
    animation: ${float} 1.5s infinite;
    font-size: 2rem;
  }
  ${({ makeItSmallerOnMobile }) =>
    makeItSmallerOnMobile &&
    css`
      @media ${devices.mobileL} {
        max-width: 70px;
        padding: 0 1.2rem;
        border-radius: 10px 10px 0 0;
        font-size: 1.2rem;
        gap: 0;
        .icon {
          font-size: 1.5rem;
        }
      }
    `};
`;
const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  margin-top: 0.8rem;
  background: #fff;
  border-radius: 12px 12px 0 0;
  box-shadow: 0 0 10px rgba(1, 1, 1, 0.1);
  padding: 1.2rem 1.6rem;
  min-width: 100px;
  a {
    all: unset;
    display: flex;
    align-items: center;
    gap: 0.7rem;
    color: #824704;
    font-size: 1.3rem;
    font-weight: 500;
    cursor: pointer;
    border-radius: 8px;
    padding: 0.5rem 0.7rem;
    transition: background 0.18s;
    &:hover {
      background: #ffe5b7;
      color: #d97706;
    }
    .icon {
      font-size: 1.5rem;
    }
  }
`;

export default function Help({
  color,
  showWhatsapp = true,
  showYoutube = true,
  showGroup = true,
  showVideoInsta = true,
  makeItSmallerOnMobile = false,
}) {
  const [open, setOpen] = useState(false);

  return (
    <Contact color={color} makeItSmallerOnMobile={makeItSmallerOnMobile}>
      {!open ? (
        <MainButton
          onClick={() => setOpen(true)}
          makeItSmallerOnMobile={makeItSmallerOnMobile}
        >
          {makeItSmallerOnMobile ? "Ajuda?" : "Precisa de ajuda?"}

          <IonIcon icon={chevronUpOutline} className="icon" />
        </MainButton>
      ) : (
        <>
          <MainButton
            style={{ animation: "none" }}
            onClick={() => setOpen(false)}
          >
            Fechar <IonIcon icon={chevronDownOutline} className="icon" />
          </MainButton>
          <OptionsWrapper>
            {showWhatsapp && (
              <a
                href={`https://wa.me/${process.env.REACT_APP_WHATSAPP_PHONE}?text=Ol%C3%A1%2C%20preciso%20de%20uma%20ajuda.`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <IonIcon icon={logoWhatsapp} className="icon" />
                Suporte WhatsApp
              </a>
            )}
            {showGroup && (
              <a
                href="https://chat.whatsapp.com/BAV8S9KWUiUGALF5YPmFhu"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IonIcon icon={peopleOutline} className="icon" />
                Grupo de usuários
              </a>
            )}
            {showYoutube && (
              <a
                href="https://www.youtube.com/@ofertas-uo3nv"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IonIcon icon={logoYoutube} className="icon" />
                Tutoriais no YouTube
              </a>
            )}
            {showVideoInsta && (
              <a
                href="https://instagram.com/ofertasexpress.videos"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IonIcon icon={logoInstagram} className="icon" />
                Peça um vídeo de impacto
              </a>
            )}
          </OptionsWrapper>
        </>
      )}
    </Contact>
  );
}
